import { ShieldCheck } from "lucide-react";

export function Logo({ size = "md", withText = true, className = "" }) {
  const dim = size === "sm" ? 28 : size === "lg" ? 44 : 34;
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <div
        className="relative flex items-center justify-center rounded-lg glow-cyan"
        style={{ width: dim, height: dim, background: "linear-gradient(135deg,#0B0E14,#1A2234)" }}
      >
        <ShieldCheck size={dim * 0.6} className="text-cyber" strokeWidth={2.2} />
        <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-secure live-dot" />
      </div>
      {withText && (
        <div className="leading-none">
          <span className="font-display font-extrabold tracking-tight text-ink text-lg">AICS</span>
          <span className="font-display font-extrabold tracking-tight text-cyber text-lg"> AGENT</span>
        </div>
      )}
    </div>
  );
}
